<template>
  <div>
    <div class="animated fadeIn">
      <b-alert :variant="dismissibleType"
               dismissible
               :show="showDismissibleAlert"
               @dismissed="showDismissibleAlert=false">
        {{ errMsg }}
      </b-alert>
      <div>
        <b-card class="p-0 m-0">
          <div slot="header" class="d-flex">
            <strong>Rate Markup Extended</strong>
            <button class="btn btn-info ml-auto" @click="saveOptions"><i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong></button>
          </div>

          <b-card-group>
            <b-card>
              <div slot="header" class="d-flex">
                <strong>Lease</strong>
                <button class="btn btn-link ml-auto" @click="addRateMarkup(true)">Add</button>
              </div>
              <div>
                <label class="h6">Current Rate Mark Ups</label>
                <DxList :data-source="rateMarkup.LeaseRateMarkUpEx">
                  <template #item="{data: item}">
                    <div>
                      <b-row>
                        <b-col md="11" @click="showEditRateMarkup(item,true)">
                          <b-row>
                            <b-col md="5">{{getLenderString(item)}}</b-col>
                            <b-col md="3">{{getSpecialStandardString(item)}}</b-col>
                            <b-col md="3">{{getTermString(item)}}</b-col>
                          </b-row>
                        </b-col>
                        <b-col md="1">
                          <button class="btn btn-link pull-right" @click="removeRateMarkup(item, true)">
                            <i class="fa fa-trash-o fa-lg" title="Delete" />
                          </button>
                        </b-col>
                      </b-row>
                    </div>
                  </template>
                </DxList>

              </div>
            </b-card>
            <b-card>
              <div slot="header" class="d-flex">
                <strong>Retail</strong>
                <button class="btn btn-link ml-auto" @click="addRateMarkup(false)">Add</button>
              </div>
              <div>
                <label class="h6">Current Rate Mark Ups</label>
                <DxList :data-source="rateMarkup.RetailRateMarkUpEx">
                  <template #item="{data: item}">
                    <div>
                      <b-row>
                        <b-col md="11" @click="showEditRateMarkup(item,false)">
                          <b-row>
                            <b-col md="5">{{getLenderString(item)}}</b-col>
                            <b-col md="3">{{getSpecialStandardString(item)}}</b-col>
                            <b-col md="3">{{getTermString(item)}}</b-col>
                          </b-row>
                        </b-col>
                        <b-col md="1">
                        <button class="btn btn-link pull-right" @click="removeRateMarkup(item, false)" ><i class="fa fa-trash-o fa-lg" title="Delete"/>
                          </button>
                        </b-col>
                      </b-row>
                    </div>
                  </template>
                </DxList>

              </div>
            </b-card>
          </b-card-group>
        </b-card>
      </div>
    </div>
    
    <b-modal id="editRateMarkup" ref="editRateMarkup" title="Edit Rate Mark Up" static
             size="xl" @ok="handleOk">
      <RateMarkUpItem ref="rateMarkUpItem" v-bind:availableLenders="availableLenders"></RateMarkUpItem>
    </b-modal>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
  import axios from 'axios'
  import loading from 'vue-full-loading'
  import cSwitch from '../components/Switch'
  import DxList from 'devextreme-vue/list'
  import RateMarkUpItem from '@/views/RateMarkUpItem'

  export default {
    components: {
      loading,
      cSwitch,
      DxList,
      RateMarkUpItem
    },
    created() {
      axios.get('/api/ratemarkup/loaddataex')
        .then(response => {
          console.log('Debug', response.data)
          this.boolLoading = false

          this.rateMarkup = response.data.rateMarkUp
          this.availableLenders = response.data.lenders

        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    data() {
      return {
        errMsg: '',
        dismissibleType: 'danger',
        showDismissibleAlert: false,
        boolLoading: false,
        txtLoading: 'Loading...',
        RateMarkUpList: ['0.00025', '0.00050', '0.00075', '0.001', '0.00125', '0.00150', '0.00175', '0.00200'],
        APRList: ['0.25', '0.50', '0.75', '1.00', '1.25', '1.50', '1.75', '2.00', '2.25', '2.50'],

        rateMarkup: {},
        availableLenders: {},
        blankMarkup: {
          Term: [],
          SpecialStandard: 0,
          Lender: []
        }

      }
    },
    methods: {
      addRateMarkup(lease) {
        if (lease === true) {
          this.currentRateMarkUp = JSON.parse(JSON.stringify(this.blankMarkup))
          this.rateMarkup.LeaseRateMarkUpEx.push(this.currentRateMarkUp)
        }
        else {
          this.currentRateMarkUp = JSON.parse(JSON.stringify(this.blankMarkup))
          this.rateMarkup.RetailRateMarkUpEx.push(this.currentRateMarkUp)
        }
      },
      removeRateMarkup(item, lease) {
        if (lease === true) {
          let index = this.rateMarkup.LeaseRateMarkUpEx.indexOf(item)
          this.rateMarkup.LeaseRateMarkUpEx.splice(index, 1)
        }
        else {
          let index = this.rateMarkup.RetailRateMarkUpEx.indexOf(item)
          this.rateMarkup.RetailRateMarkUpEx.splice(index, 1)
        }
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        //bvModalEvt.preventDefault()
        // Trigger submit handler
        this.saveOptions()
      },
      saveOptions() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (!this.rateMarkup) {
              this.errMsg = 'Unknown error.'
              this.showDismissibleAlert = true
              return
            }

            this.boolLoading = true
            var obj = {}
            obj.data = this.rateMarkup


            axios.post('/api/ratemarkup/save', obj)
              .then(response => {
                this.errMsg = 'Rate Markup Saved'
                this.dismissibleType = 'success'
                this.showDismissibleAlert = true
                this.boolLoading = false
              })
              .catch(error => {
                if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { this.$router.push('/login') }

                console.log(error)
                this.boolLoading = false
                this.errMsg = 'There was an error saving data : ' + error
                this.showDismissibleAlert = true

                if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { this.errMsg = error.response.statusText.replace('403.1', '') }
              })
          }
        })
      },
      showEditRateMarkup(item, isLease) {
        console.log(item)

        this.$refs.editRateMarkup.show()
        this.$refs.rateMarkUpItem.currentRateMarkUp = item
        this.$refs.rateMarkUpItem.$props.isLease = isLease
      },
      getLenderString: function (item) {
        var lenders = ''
        if (item.Lender !== null && item.Lender !== undefined && item.Lender.length !== 0) {   
            
          lenders = item.Lender[0].Name
          if (item.Lender.length > 1) {
            lenders += ' and others...'
          }
          
        }
        else {
          lenders = 'All Lenders'
        }
        return lenders
      },
      getTermString: function (item) {
        var terms = ''
        if (item.Term != undefined) {
          item.Term.forEach(t => terms = terms +' '+  t.Term)
        }
        else {
          lenders = 'All Terms'
        }
        return terms
      },
      getSpecialStandardString: function (item) {
        if (item.SpecialStandard == 1)
          return 'Special'
        else if (item.SpecialStandard == 2)
          return 'Standard'
        else
          return 'Both'
      }

    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/RateMarkupEx.vue